exports.buildSubmittingState = () => {

    return {
        submitting: true,
        pageIsBlocking: false,
        pageHasErrors: false
    };
};

exports.buildSubmitSettledState = ({ pageHasErrors = false } = {}) => {

    return {
        pageIsBlocking: false,
        pageHasErrors,
        submitting: false
    };
};

exports.setSubmitSettledStateIfMounted = ({
    stillExists,
    setUiState,
    pageHasErrors = false
}) => {

    if (!stillExists) {
        return;
    }

    setUiState(exports.buildSubmitSettledState({
        pageHasErrors
    }));
};
